import { trackEvent } from "../../utils/analytics";
import axiosInstance from "../../APIs/axiosInstance";

const NETWORK_BADGES = {
  amazon:   { label: "Amazon",   color: "#FF9900", bg: "rgba(255,153,0,0.12)" },
  flipkart: { label: "Flipkart", color: "#2874F0", bg: "rgba(40,116,240,0.12)" },
  meesho:   { label: "Meesho",   color: "#F43397", bg: "rgba(244,51,151,0.12)" },
  myntra:   { label: "Myntra",   color: "#FF3F6C", bg: "rgba(255,63,108,0.12)" },
  custom:   { label: "Custom",   color: "#8B5CF6", bg: "rgba(139,92,246,0.12)" },
};

const getDomain = (url) => {
  try { return new URL(url).hostname.replace("www.", ""); }
  catch { return url; }
};

const getFavicon = (url) => {
  const domain = getDomain(url);
  return `https://www.google.com/s2/favicons?domain=${domain}&sz=64`;
};

export default function LinkCard({ link, postId, isOwner, onEdit, onDelete }) {
  const handleClick = () => {
    trackEvent("link_click", { postId, metadata: { link_url: link.url } });
    if (postId) {
      axiosInstance.post(`posts/${postId}/click/`, { link: link.url }).catch(() => {});
    }
  };

  const badge = NETWORK_BADGES[link.affiliate_network];

  return (
    <div className="flex items-center gap-3.5 p-3.5 rounded-2xl bg-white/[0.04] border border-white/[0.06]">
      {/* Favicon */}
      <div className="w-[42px] h-[42px] rounded-xl bg-white/[0.06] flex items-center justify-center shrink-0 border border-white/[0.05]">
        <img
          src={getFavicon(link.url)}
          alt=""
          className="w-[22px] h-[22px] rounded"
          onError={(e) => {
            e.target.style.display = "none";
            e.target.parentElement.innerHTML =
              '<span style="font-size:18px;color:rgba(255,255,255,0.3)">🔗</span>';
          }}
        />
      </div>

      {/* Content */}
      <a
        href={link.url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleClick}
        className="flex-1 min-w-0 no-underline"
      >
        <div className="flex items-center gap-2 mb-0.5">
          <span className="text-[15px] font-medium text-[#f0f0f0] truncate">
            {link.label || getDomain(link.url)}
          </span>
          {badge && (
            <span
              className="shrink-0 text-[10px] font-semibold px-1.5 py-0.5 rounded-md"
              style={{ color: badge.color, background: badge.bg }}
            >
              {badge.label}
            </span>
          )}
        </div>
        {link.product_name && (
          <div className="text-xs text-white/45 truncate mb-0.5">{link.product_name}</div>
        )}
        {link.product_price && (
          <div className="text-xs text-indigo-400 font-semibold mb-0.5">
            ₹{parseFloat(link.product_price).toLocaleString("en-IN")}
          </div>
        )}
        <div className="text-xs text-white/25 font-mono truncate">{getDomain(link.url)}</div>
      </a>

      {/* Owner controls or arrow */}
      {isOwner ? (
        <div className="flex items-center gap-1 shrink-0">
          {onEdit && (
            <button
              onClick={onEdit}
              className="w-7 h-7 rounded-lg bg-white/[0.06] flex items-center justify-center
                text-white/40 text-xs hover:bg-white/[0.12] hover:text-white/70 transition-colors"
            >
              ✎
            </button>
          )}
          {onDelete && (
            <button
              onClick={onDelete}
              className="w-7 h-7 rounded-lg bg-white/[0.06] flex items-center justify-center
                text-white/40 text-xs hover:bg-red-500/20 hover:text-red-400 transition-colors"
            >
              ✕
            </button>
          )}
        </div>
      ) : (
        <span className="text-white/20 text-base shrink-0">↗</span>
      )}
    </div>
  );
}
